import apibase from './BaseAPI';

export const getAreas = async () => {
    const url = `/locations/area`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

export default {
    getAreas: getAreas,
}